import { FirestoreDataConverter } from "firebase/firestore";
import { omit } from "lodash";
import Calculo from "../models/calculo";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";

export default class CalculoDb extends BaseDb<
  Calculo,
  { usuarioId: string; calculoId: string }
> {
  _path: string = "usuarios/usuarioId/calculos/calculoId";
  getConverter(): FirestoreDataConverter<Calculo> {
    return {
      fromFirestore: (snapshot, _options) => Calculo.fromFirestore(snapshot),
      toFirestore: (calculo) => toFirestore(omit(calculo, ["id"])),
    };
  }
}
